module.exports = __webpack_public_path__ + "img/qiyeweixin.0f9cbaba.png";